"use client"

import { useEffect, useRef, useState } from 'react'

const loadDialog = () => import('./VinDialog')

// Obsługa kafelka VehicleHistory (poprzedni element): kod okna pobierany przy najechaniu lub fokusie,
// okno montowane przy pierwszym kliknięciu.
export default function VinDialogHost ({ vin }) {
    const ref = useRef(null)
    const [Dialog, setDialog] = useState(null)
    const [request, setRequest] = useState({ n: 0, opener: null })

    useEffect(() => {
        const button = ref.current?.previousElementSibling
        if (!button) return
        const prefetch = () => { loadDialog() }
        const open = () => {
            loadDialog().then(m => {
                setDialog(() => m.default)
                setRequest(r => ({ n: r.n + 1, opener: button }))
            })
        }
        button.addEventListener('pointerenter', prefetch, { once: true })
        button.addEventListener('focus', prefetch, { once: true })
        button.addEventListener('click', open)
        return () => {
            button.removeEventListener('pointerenter', prefetch)
            button.removeEventListener('focus', prefetch)
            button.removeEventListener('click', open)
        }
    }, [])

    return <>
        <span hidden ref={ref} />
        { Dialog && <Dialog request={request} vin={vin} /> }
    </>
}
